var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.headCls, on: { click: _vm.onHeaderClick } },
    [
      _vm.$slots.prefix || _vm.prefix
        ? _c(
            "span",
            { class: [_vm.prefixCls + "-prefix"] },
            [
              _vm._t("prefix", function() {
                return [
                  _vm.prefix
                    ? _c("Icon", { attrs: { type: _vm.prefix } })
                    : _vm._e()
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.selectedMultiple, function(item, index) {
        return _vm.maxTagCount === undefined || index < _vm.maxTagCount
          ? _c(
              "div",
              { staticClass: "ivu-tag ivu-tag-checked" },
              [
                _c(
                  "span",
                  {
                    staticClass: "ivu-tag-text",
                    class: { "ivu-select-multiple-tag-hidden": item.disabled }
                  },
                  [
                    _vm._v(
                      _vm._s(item.tag !== undefined ? item.tag : item.label)
                    )
                  ]
                ),
                _vm._v(" "),
                !item.disabled
                  ? _c("Icon", {
                      attrs: { type: "ios-close" },
                      nativeOn: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.removeTag(item)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      }),
      _vm.maxTagCount !== undefined &&
      _vm.selectedMultiple.length > _vm.maxTagCount
        ? _c("div", { staticClass: "ivu-tag ivu-tag-checked" }, [
            _c(
              "span",
              { staticClass: "ivu-tag-text ivu-select-max-tag" },
              [
                _vm.maxTagPlaceholder
                  ? [
                      _vm._v(
                        _vm._s(
                          _vm.maxTagPlaceholder(
                            _vm.selectedMultiple.length - _vm.maxTagCount
                          )
                        )
                      )
                    ]
                  : [
                      _vm._v(
                        "+ " +
                          _vm._s(
                            _vm.selectedMultiple.length - _vm.maxTagCount
                          ) +
                          "..."
                      )
                    ]
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.singleDisplayValue,
              expression: "singleDisplayValue"
            }
          ],
          class: _vm.singleDisplayClasses
        },
        [_vm._v(_vm._s(_vm.singleDisplayValue))]
      ),
      _vm._v(" "),
      _vm.filterable
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.query,
                expression: "query"
              }
            ],
            ref: "input",
            class: [_vm.prefixCls + "-input"],
            style: _vm.inputStyle,
            attrs: {
              id: _vm.inputElementId,
              type: "text",
              disabled: _vm.disabled,
              placeholder: _vm.showPlaceholder ? _vm.localePlaceholder : "",
              autocomplete: "off",
              spellcheck: "false"
            },
            domProps: { value: _vm.query },
            on: {
              keydown: [
                _vm.resetInputState,
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                      "Backspace",
                      "Delete",
                      "Del"
                    ])
                  ) {
                    return null
                  }
                  return _vm.handleInputDelete.apply(null, arguments)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleInputEnter.apply(null, arguments)
                }
              ],
              focus: _vm.onInputFocus,
              blur: _vm.onInputBlur,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.query = $event.target.value
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.resetSelect
        ? _c("Icon", {
            class: [_vm.prefixCls + "-arrow"],
            attrs: { type: "ios-close-circle" },
            nativeOn: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.onClear.apply(null, arguments)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.resetSelect && !_vm.remote
        ? _c("Icon", {
            class: [_vm.prefixCls + "-arrow"],
            attrs: {
              type: _vm.arrowType,
              custom: _vm.customArrowType,
              size: _vm.arrowSize
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-953048d0", { render: render, staticRenderFns: staticRenderFns })
  }
}